function injectStyle (ssrContext) {
  require("!!../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0dea2bc3\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CalendarPopup.vue")
}
var Component = require("!../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CalendarPopup.vue"),
  /* template */
  require("!!../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0dea2bc3\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CalendarPopup.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0dea2bc3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/remote-edu/calendar/components/popup/CalendarPopup.vue
// module id = 50919e6f341511410c38
// module chunks = 7